<div class="notifications">
    <button mat-icon-button class="notifications__envelop" title="Show Notifications" [routerLink]="['/v2/notifications']">
        <mat-icon svgIcon="{{ IconsEnum.MESSAGES_DARK }}" [inline]="true"></mat-icon>
    </button>
    <div class="notifications__badge badge">{{ notificationsCount < 99 ? notificationsCount : '99+' }}</div>
</div>
